import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { type: String }
  }

  markAsRead() {
    this.dispatch("read", { detail: { type: this.typeValue } })
    this.element.setAttribute("data-status", "read")
  }
}
